import * as React from 'react';
import axios from 'axios';
import { DataPicto } from '../cart/iCart';
import { getShopInfosInStorage } from '../cart/ShopInfos';
import { getShopRefInStorage, getUserId, sessionExpire} from './MonCompteAction';
import Modal from 'react-responsive-modal';
import Icons from './Icons';
import {getHostApi, getRequestConfig} from '../../utils';
import { Picto } from '@dp/website-components';
import { HexaColor } from '@dp/website-components/dist/types';

interface PictoState {
  dataPicto?: DataPicto;
  open: boolean;
}

export class RenderPicto extends React.Component<any, PictoState> {
  constructor(props: any) {
    super(props);
    this.state = {
      open: false
    };
  }

  componentDidMount(): void {
    this._getDatasPicto();
  }

  componentWillReceiveProps(nextProps: any, nextContext: any): void {
    if(this.props.surface.id != nextProps.surface.id
        || this.props.emplacement.id != nextProps.emplacement.id
        || this.props.picto.id != nextProps.picto.id) {
      this._getDatasPicto();
    }
  }

  _getDatasPicto = () => {
    axios.get(getHostApi() + '/shops/pictogrammes/datas/' + this.props.surface.id + '/' +
      this.props.emplacement.id + '/' + this.props.picto.id, getRequestConfig()).then((response) => {
        if (response.data) {
          this.setState({ dataPicto: response.data });
        }
      }).catch((error) => {
        console.log('error', error);
        if (error.response.status === 401) {
          sessionExpire();
        }
      });
  }

  /**
   * Actions à exécuter à l'ouverture de la modal
   *
   * @param {React.MouseEvent<HTMLDivElement>} event
   * @private
   */
  _onClickModal = () => {
    this.onOpenModal();
  }

  /**
   * Ouverture de la modal
   */
  onOpenModal = () => {
    this.setState({ open: true });
  }

  /**
   * Fonction permettant la fermeture de la modal galerie
   */
  onCloseModal = () => {
    this.setState({ open: false });
  }

  render() {

    /**
     * Rendu de la modal avec pictogramme plaqué en taille réelle
     * @returns {any}
     */
    const renderZoomModal = (bgTextile: string) => {
      const srcImg = `${getHostApi()}/customers/${getUserId()}/orders/${this.props.orderId}/image-files?nom=${this.props.preview.filename}&numCommande=${this.props.numCommande}&path=${this.props.preview.path}&validated=true&xsrf=${localStorage.getItem('xsrfToken')}`;
      return (
        <Modal open={this.state.open} onClose={this.onCloseModal} center
               classNames={{overlay: 'bootstrap-container', modal: 'zoomPictoModalContainer customModal',
                 closeButton: 'zoomPictoModalCloseButton closeButton'}}>
          <div className="modalOrder p-2 pa0Mobile"
               style={{ maxHeight: '760px', overflow: 'auto'}}>
            <div className="text-center">
              <img src={srcImg}
                   style={{ maxHeight: '740px', maxWidth: '100%', backgroundColor: bgTextile }} className={`imgPicto ${getShopRefInStorage() === 'DT' ? 'bg-alpha' : ''}`}
                   id={'imgPicto-' + this.props.id} />
              {this.props.isBroderie && <div className="bg-white black text-center small" style={{border: "1px solid rgb(222, 226, 230)", width: "100%"}}>
                <span>Maquette de positionnement</span></div>}
            </div>
          </div>
        </Modal>
      );
    };

    /**
     * Rendu du pictogramme
     *
     * @returns {any}
     */
    const renderPicto = () => {
      const bgTextile: HexaColor = this.props.cmjnCustom?.isPersonnalise ? `#${this.props.cmjnCustom.hexadecimal}` : `#${this.props.color.code1}`;
      if ( this.state.dataPicto  && (!this.props.preview || !this.props.preview.filename || this.props.activateBatAuto === false) &&
        this.props.picto.nom != 'indefini') {
        return (
          <Picto
            srcImg={this.state.dataPicto.image}
            size={60}
            hexadecimal={bgTextile}
            coordonnees={{
              pictoId: parseInt(this.state.dataPicto.id),
              surfaceEmplacementId: parseInt(this.state.dataPicto.surface_emplacement_id),
              paysage_x: parseInt(this.state.dataPicto.paysage_x),
              paysage_y: parseInt(this.state.dataPicto.paysage_y),
              portrait_x: parseInt(this.state.dataPicto.portrait_x),
              portrait_y: parseInt(this.state.dataPicto.portrait_y),
              x: parseInt(this.state.dataPicto.x),
              x_web: parseInt(this.state.dataPicto.x_web),
              y: parseInt(this.state.dataPicto.y),
              y_web: parseInt(this.state.dataPicto.y_web)
            }}
          />
        );
      }
      if (this.state.dataPicto && (!this.props.preview || !this.props.preview.filename || this.props.activateBatAuto === false) &&
        this.props.picto.nom == 'indefini') {
        return (
          <div className="blocPictoIndefini d-flex align-middle justify-content-center
          align-items-center uploadPicto"
               style={{ width:'60px', height: '60px', backgroundColor:  bgTextile }}>
            <span className="rotate45 lineheight1 text-center white"  style={{ textShadow: 'black 0.1em 0.1em 0.4em' }}> {this.props.surface.nom}</span>
          </div>
        );
      }
      // Pour les tiffs et les quadriluxe
      const displayPreviewBat = this.props.preview && this.props.preview.filename && this.props.preview.filename !== '';
      if (displayPreviewBat) {
        let srcImg = `${getHostApi()}/customers/${getUserId()}/orders/${this.props.orderId}/image-files?nom=${this.props.preview.filename}&numCommande=${this.props.numCommande}&path=${this.props.preview.path}&validated=true&xsrf=${localStorage.getItem('xsrfToken')}`;
        if(this.props.previewIsUpdated) {
          srcImg = `${srcImg}&cache=${Date.now()}`;
          this.props.resetPreviewIsUpdated(false);
        }
        const isDT = getShopRefInStorage() === 'DT';
        const styleBgColor = isDT && bgTextile === '#ffffff' ? {} : {backgroundColor: bgTextile};
        const classContainer = isDT && bgTextile === '#ffffff' ? 'bg-alpha-bat-auto' : '';
        return (
          <>
            <div className="position-relative uploadPicto">
              <div className="picto-teeshirt bg-white1 cursor-pointer text-center"
                   onClick={this._onClickModal}>
                <span className="position-relative d-block">
                  <img src={srcImg} width={'100%'} className={`imgPicto imgPictoBat ${classContainer}`} id={this.props.id} style={styleBgColor}/>
                </span>
              </div>
              <div className="position-absolute cursor-pointer bg-white border" style={{ bottom: '0', right: '0'}}
                   onClick={this._onClickModal}>
                <Icons icon="zoom_in" size={25}/>
              </div>
              {renderZoomModal(bgTextile)}
            </div>
            {this.props.isBroderie && <div className="bg-white black text-center" style={{border: "1px solid rgb(222, 226, 230)", width: "100%", fontSize: 9}}>
              <span>Maquette de positionnement</span></div>}
        </>
        );
      }
    };

    const shopInfos = getShopInfosInStorage();
    /** Pour les tests */
    // shopInfos.Ref = "MT";
    if (shopInfos.Ref != 'MT' && shopInfos.Ref != 'ME') {
      return (
        <div>
          {renderPicto()}
        </div>
      );
    }
  }
}
